export default __webpack_public_path__ + "static/media/189g.990cd292.svg";